import * as React from 'react';
import styled from 'styled-components';
import { s3ToCDN } from '@doltech/utils/lib/url';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import {
  InputCaptionComponentReadOnly,
} from '@doltech/ui/lib/figma/DolEditor/elements/BlogEditor/MediaLogic/component/InputCaptionComponentReadOnly';

// height image accordingly to width and ratio 4 / 3

const StyleFigcaption = styled.figure`
  display: grid;
  grid-template-columns: minmax(0, 1fr);

  ${fromScreen(768)} {
    padding-bottom: 26px;
  }

  ${fromScreen(1240)} {
    padding-bottom: 0;
  }

  img {
    width: 100%;
    aspect-ratio: 4 /3;
    border-radius: 4px;
    object-fit: cover;

    ${fromScreen(768)} {
      width: 712px;
      border-radius: 8px;
      object-fit: cover;
    }
  }
`;

interface ThumbnailBlogGrammarProps {
  image?: any;
  alt?: string;
  caption?: string;
  imgTitle?: string;
  isReadOnly?: boolean;
  onUpdate?: (value: any) => void;
}

export const ThumbnailBlogGrammar = (props: ThumbnailBlogGrammarProps) => {
  const { image, alt, caption, imgTitle } = props;
  const fileUrl = image?.path ? s3ToCDN(image?.path) : image?.url;

  return (
    <StyleFigcaption className="thumbnai-blog-grammar">
      <img title={imgTitle} src={fileUrl || ''} alt={alt}/>
      <InputCaptionComponentReadOnly caption={caption}/>
    </StyleFigcaption>
  );
};
